import { LOCAL_STORAGE, SESSION_STORAGE } from '../constants/AppConstants'

/**
 * Browser Storage Utilities
 */

/**
 * Usage examples:
 * storageAvailable('sessionStorage')
 * storageAvailable('localStorage')
 */
export const storageAvailable = type => {
  let storage
  try {
    storage = window[type]
    const x = '__storage_test__'
    storage.setItem(x, x)
    storage.removeItem(x)
    return true
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage.length !== 0
    )
  }
}

export const setStoredValue = ({ type, key, value }) => {
  if (storageAvailable(type)) {
    switch (type) {
      case SESSION_STORAGE:
        sessionStorage.setItem(key, value)
        break

      case LOCAL_STORAGE:
      default:
        localStorage.setItem(key, value)
    }
  }
}

export const getStoredValue = ({ type, key }) => {
  if (storageAvailable(type)) {
    switch (type) {
      case SESSION_STORAGE:
        return sessionStorage.getItem(key)

      case LOCAL_STORAGE:
      default:
        return localStorage.getItem(key)
    }
  }
  return undefined
}

export const clearStoredValue = ({ type, key }) => {
  if (storageAvailable(type)) {
    switch (type) {
      case SESSION_STORAGE:
        sessionStorage.removeItem(key)
        break

      case LOCAL_STORAGE:
      default:
        localStorage.removeItem(key)
    }
  }
}
